import { render } from "./DanhSachXe.vue?vue&type=template&id=77ca0f8a&scoped=true"
import script from "./DanhSachXe.vue?vue&type=script&lang=js"
export * from "./DanhSachXe.vue?vue&type=script&lang=js"

import "./DanhSachXe.vue?vue&type=style&index=0&id=77ca0f8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ca0f8a"]])

export default __exports__